import React from 'react';
import {Flex} from "antd";
import styled from "./ProductDescription.module.scss"
import {ProductDescriptionProps} from "../../models/ProductDescriptionProps";

const ProductDescription = ({data} : ProductDescriptionProps) => {
    return (
        <Flex vertical gap={"middle"}>
            <p
                aria-readonly
                dangerouslySetInnerHTML={{__html: data}}
            ></p>
        </Flex>
    );
};

export default ProductDescription;